<template>
  <component :is="tag" :class="textClasses">
    <slot />
  </component>
</template>

<script setup lang="ts">
import { computed, PropType } from "vue";
import {
  BOOTSTRAP_FONT_WEIGHTS,
  FONT_WEIGHT_REGULAR,
  TEXT_FONT_SIZES,
  TEXT_MD,
  TYPOGRAPHY_FONT_WEIGHTS,
} from "@/designSystem/Typography/constant";
import type { FontSizeType, FontWeightType } from "@/designSystem/Typography/constant";

const props = defineProps({
  color: {
    type: String,
    required: false,
  },

  fontSize: {
    type: String as PropType<FontSizeType>,
    default: TEXT_MD,
    validator: (value: string): boolean => {
      return (Object.values(TEXT_FONT_SIZES) as string[]).includes(value);
    },
  },

  fontWeight: {
    type: String as PropType<FontWeightType>,
    default: FONT_WEIGHT_REGULAR,
    validator: (value: string) => Object.keys(TYPOGRAPHY_FONT_WEIGHTS).includes(value),
  },

  italic: {
    type: Boolean,
    default: false,
  },

  upperCase: {
    type: Boolean,
    default: false,
  },

  paragraph: {
    type: Boolean,
    default: false,
  },
});

const tag = computed(() => (props.paragraph ? "p" : "span"));

const textClasses = computed(() => {
  return [
    props.color ? `text-${props.color}` : "",
    props.fontWeight ? BOOTSTRAP_FONT_WEIGHTS[TYPOGRAPHY_FONT_WEIGHTS[props.fontWeight]] : "",
    props.fontSize ? `fs-${props.fontSize}` : "",
    props.upperCase ? "text-uppercase" : "",
    props.italic ? "font-italic" : "",
  ]
    .filter(Boolean)
    .join(" ");
});
</script>

<style lang="scss" scoped>
@import "@/designSystem/style/main.scss";
@import "@/designSystem/style/variables/_font.scss";

p,
span {
  font-family: $font-family-base;
  color: inherit;
}
</style>
